import { z } from "zod";

export enum TokenStatus {
  Active = "active",
  Revoked = "revoked",
  Expired = "expired",
}

export enum AccessTokenRateLimitScope {
  Api = "api",
}

export const accessTokenRateLimitSchema = z.object({
  max_attempts: z.number(),
  decay_minutes: z.number(),
  scope: z.enum(AccessTokenRateLimitScope).nullable(),
});

export type AccessTokenRateLimit = z.infer<typeof accessTokenRateLimitSchema>;

export const accessTokenSchema = z.object({
  id: z.number(),
  name: z.string(),
  description: z.string().nullable(),
  created_at: z.iso.datetime(),
  expires_at: z.iso.datetime().nullable(),
  last_used_at: z.iso.datetime().nullable(),
  revoked_at: z.iso.datetime().nullable(),
  abilities: z.array(z.string()),
  status: z.enum(TokenStatus),
  rate_limits: z.array(accessTokenRateLimitSchema),
});

export type AccessToken = z.infer<typeof accessTokenSchema>;

export const createdAccessTokenSchema = accessTokenSchema.extend({
  token: z.string(),
});

export type CreatedAccessToken = z.infer<typeof createdAccessTokenSchema>;
